/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import RequestDrugPriceLoadManufactureTable from './component/RequestDrugPriceLoadManufactureTable';
import ReuestDrugPriceLoadSearchComponent from './component/ReuestDrugPriceLoadSearchComponent';
import { dataSourceRadioData } from './utils/constant';
import { checkActionAccessByRole } from '../../../SharedModules/utilities/utilities';

const RequestDrugPriceLoad = () => {
  const history = useHistory();
  const [fullScreen, setFullScreen] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [fieldError, setFieldError] = useState(null);
  const [successMessages, setSuccessMessages] = useState([]);

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  const loading = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.loading
  );
  const searchFilter = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.searchFilter
  );

  useEffect(() => {
    if (kcRoles?.userPrivileges?.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, [kcRoles]);

  const navigateToPage = (pathName, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: pathName,
    });
  };

  useEffect(() => {
    const ele = document.querySelector('.nav-item-active a .tab-title');
    if (ele) {
      ele.textContent = 'Request Drug Price Load';
    }
  }, []);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/RequestDrugPriceLoad') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  return (
    <div className="tabs-container tBillPanel custom-check">
      {loading && <Spinner load={loading} />}
      <CustomSeparator parent1="Invoice" parent2="Request Drug Price Load" />
      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      {errorMessages && (
        <DisplayErrorMessages errorMessages={[...new Set(errorMessages)]} />
      )}
      {!fullScreen && (
        <ReuestDrugPriceLoadSearchComponent
          searchFilter={searchFilter}
          navigateToPage={navigateToPage}
          errorMessages={errorMessages}
          successMessages={successMessages}
          setErrorMessages={setErrorMessages}
          fieldError={fieldError}
          setFieldError={setFieldError}
          setSuccessMessages={setSuccessMessages}
          isEnablebyRole={isEnablebyRole}
        />
      )}
      {searchFilter &&
        searchFilter.dataSource !== dataSourceRadioData[2].value && (
          <RequestDrugPriceLoadManufactureTable
            searchFilter={searchFilter}
            navigateToPage={navigateToPage}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
            setErrorMessages={setErrorMessages}
            setSuccessMessages={setSuccessMessages}
            setFieldError={setFieldError}
          />
        )}
    </div>
  );
};

export default RequestDrugPriceLoad;
